import { render, staticRenderFns } from "./ModattaSideModalCashbackOverview.vue?vue&type=template&id=4cc2923e"
import script from "./ModattaSideModalCashbackOverview.vue?vue&type=script&lang=js"
export * from "./ModattaSideModalCashbackOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports